const PLAYER_CONFIGS = [
    { minPlayers: 4, maxPlayers: 4, deckCount: 1, dealtCards: 13, bidRange: [125, 250], bidIncrement: 5, partnerCount: 1 }, // 2v2
    { minPlayers: 5, maxPlayers: 5, deckCount: 1, dealtCards: 10, bidRange: [125, 250], bidIncrement: 5, partnerCount: 1 }, // 2v3
    { minPlayers: 6, maxPlayers: 6, deckCount: 1, dealtCards: 8, bidRange: [125, 250], bidIncrement: 5, partnerCount: 2 }, // 3v3
    { minPlayers: 7, maxPlayers: 7, deckCount: 2, dealtCards: 14, bidRange: [250, 500], bidIncrement: 5, partnerCount: 2 }, // 3v4
    { minPlayers: 8, maxPlayers: 8, deckCount: 2, dealtCards: 12, bidRange: [250, 500], bidIncrement: 5, partnerCount: 3 }, // 4v4
    { minPlayers: 9, maxPlayers: 9, deckCount: 2, dealtCards: 11, bidRange: [250, 500], bidIncrement: 5, partnerCount: 3 }, // 4v5
    { minPlayers: 10, maxPlayers: 10, deckCount: 2, dealtCards: 10, bidRange: [250, 500], bidIncrement: 5, partnerCount: 4 }, // 5v5
];
export function getPlayerConfig(playerCount) {
    return PLAYER_CONFIGS.find(config => playerCount >= config.minPlayers && playerCount <= config.maxPlayers) || null;
}
/**
 * Get the bid range for a specific player count
 */
export function getBidRangeForPlayerCount(playerCount) {
    const config = getPlayerConfig(playerCount);
    return config ? config.bidRange : [125, 250];
}
/**
 * Get number of partners to select based on player count and team structure
 *
 * @param playerCount - Number of players in the game
 * @param partnershipConfig - Optional partnership configuration string (e.g., "2p", "3p", "4p")
 *                           Format: "Xp" where X = total bidding team size (bidder + partners)
 *                           Examples:
 *                           - "2p" = 2 total on team = 1 bidder + 1 partner (so return 1)
 *                           - "3p" = 3 total on team = 1 bidder + 2 partners (so return 2)
 *                           - "4p" = 4 total on team = 1 bidder + 3 partners (so return 3)
 * @returns Number of partners the bidder should select
 */
export function getPartnerCount(playerCount, partnershipConfig) {
    console.log(`🎯 getPartnerCount called with playerCount=${playerCount}, partnershipConfig="${partnershipConfig}"`);
    console.log(`🔍 DEBUG: partnershipConfig type=${typeof partnershipConfig}, length=${partnershipConfig?.length}, exact value:`, JSON.stringify(partnershipConfig));
    // If partnership config is provided, handle it
    if (partnershipConfig) {
        // Special case: 6-2deck variant = 6 players, 2 decks, 3v3 teams (2 partners)
        const is6Deck = partnershipConfig === '6-2deck';
        console.log(`🔍 DEBUG: Checking '6-2deck': partnershipConfig === '6-2deck' = ${is6Deck}`);
        if (is6Deck) {
            console.log(`✅ 6-2deck variant detected: 3v3 teams = 2 partners for bidder - RETURNING 2`);
            return 2;
        }
        // Standard format: "2p", "3p", "4p" etc.
        const match = partnershipConfig.match(/(\d+)p/);
        if (match) {
            const totalBiddingTeam = parseInt(match[1], 10);
            // Subtract 1 for the bidder to get number of partners
            const partnerCount = totalBiddingTeam - 1;
            console.log(`🎯 Partnership config "${partnershipConfig}" parsed: ${totalBiddingTeam} total on team = ${partnerCount} partners for ${playerCount} players`);
            return partnerCount;
        }
        else {
            console.warn(`⚠️ Partnership config "${partnershipConfig}" did not match known patterns`);
        }
    }
    else {
        console.log(`ℹ️ No partnershipConfig provided, using default for ${playerCount} players`);
    }
    // Default partner count based on player count
    // Format: XvY where X = bidder + partners (total), Y = opponents
    switch (playerCount) {
        case 4:
            return 1; // 2v2: 1 bidder + 1 partner vs 2 opponents (Traditional)
        case 5:
            return 1; // 2v3: 1 bidder + 1 partner vs 3 opponents
        case 6:
            return 1; // 2v4: 1 bidder + 1 partner vs 4 opponents
        case 7:
            return 2; // 3v4: 1 bidder + 2 partners vs 4 opponents
        case 8:
            return 2; // 3v5: 1 bidder + 2 partners vs 5 opponents
        case 9:
            return 3; // 4v5: 1 bidder + 3 partners vs 5 opponents
        case 10:
            return 3; // 4v6: 1 bidder + 3 partners vs 6 opponents
        default:
            return 1; // Default fallback
    }
}
//# sourceMappingURL=gameUtils.js.map